<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/inspection/rules/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('guizebianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('guizemingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_base_inspection_rules_create')" size="mini" @click="yt.showEditDialog('xinzeng', null, '70%')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_inspection_rules_update')" @click="yt.showEditDialog('bianji', scope.row, '70%')">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_inspection_rules_delete')" class="font-color-danger" @click="yt.remove(scope.row, '/web/inspection/rules/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div style="flex:1;display:flex;flex-direction:column" class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('zhijianguizebianma')" required>
              <el-input v-model="yt.editObj.code" :maxlength="200"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhijianguizemingcheng')" required>
              <el-input v-model="yt.editObj.name" :maxlength="200"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" :rows="6" :placeholder="$t('qingshuruneirong')" v-model="yt.editObj.remark" :maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <p style="font-size: 20px; font-weight: bold; color: black; margin-bottom: 20px;">
            {{ $t('tiaojianshezhi') }}
          </p>
          <el-button size="mini" @click="yt.editObj.addObj = {};showCondition = true" type="primary" style="margin-bottom: 20px; width: 80px">
            {{ $t('xinzeng') }}
          </el-button>
          <!-- 表格 -->
          <div style="flex:1">
            <el-table :data="yt.editObj.conditionSettingVOS" border style="width: 100%">
              <el-table-column type="index" :label="$t('paixu')" width="180" sortable></el-table-column>
              <el-table-column prop="startQuantity" :label="$t('qishishuliang')" width="180" sortable></el-table-column>
              <el-table-column prop="endQuantity" :label="$t('jieshushuliang')" width="180" sortable></el-table-column>
              <el-table-column prop="sampleQuantity" :label="$t('yangbenshuliang')" width="180" sortable></el-table-column>
              <el-table-column prop="inspectionPercentage" :label="$t('jianyanbaifenbi(%)')" width="180" sortable></el-table-column>
              <el-table-column prop="minimumInspectionQuantity" :label="$t('zuixiaozhijianshu')" width="180" sortable></el-table-column>
              <el-table-column fixed="right" :label="$t('caozuo')" width="180">
                <template slot-scope="scope">
                  <el-button type="text" v-if="utils.checkPower('web_base_inspection_rules_delete')" class="font-color-danger" @click="removeByIndex(scope.$index)">{{ $t('shanchu') }} </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="mini"
            @click="
              yt.isShowEditDialog = false;
              clearTableData();
            "
            >{{ $t('quxiao') }}</el-button
          >
          <el-button @click="yt.req('POST', '/web/inspection/rules/create' )" :loading="yt.editObj.loading" size="mini" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div style="flex:1;display:flex;flex-direction:column" class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('zhijianguizebianma')" required >
              <el-input v-model="yt.editObj.code" :maxlength="200" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('zhijianguizemingcheng')" required>
              <el-input v-model="yt.editObj.name" :maxlength="200"></el-input>
            </el-form-item>
            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" :rows="6" :placeholder="$t('qingshuruneirong')" v-model="yt.editObj.remark" :maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </el-form>
          <p style="font-size: 20px; font-weight: bold; color: black; margin-bottom: 20px;">
            {{ $t('tiaojianshezhi') }}
          </p>
          <el-button size="mini" @click="yt.editObj.addObj = {};showCondition = true" type="primary" style="margin-bottom: 20px; width: 80px">
            {{ $t('xinzeng') }}
          </el-button>
          <!-- 表格 -->
          <div style="flex:1">
            <el-table :data="yt.editObj.conditionSettingVOS" border style="width: 100%">
              <el-table-column :type="'index'" :label="$t('paixu')" width="50" sortable></el-table-column>
              <el-table-column prop="startQuantity" :label="$t('qishishuliang')" width="180" sortable></el-table-column>
              <el-table-column prop="endQuantity" :label="$t('jieshushuliang')" width="180" sortable></el-table-column>
              <el-table-column prop="sampleQuantity" :label="$t('yangbenshuliang')" width="180" sortable></el-table-column>
              <el-table-column prop="inspectionPercentage" :label="$t('jianyanbaifenbi(%)')" width="180" sortable></el-table-column>
              <el-table-column prop="minimumInspectionQuantity" :label="$t('zuixiaozhijianshu')" width="180" sortable></el-table-column>
              <el-table-column fixed="right" :label="$t('caozuo')">
                <template slot-scope="scope">
                  <el-button type="text" v-if="utils.checkPower('web_base_inspection_rules_delete')" class="font-color-danger" @click="removeByIndex(scope.$index)">{{ $t('shanchu') }} </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            size="mini"
            @click="
              yt.isShowEditDialog = false;
              clearTableData();
            "
            >{{ $t('quxiao') }}</el-button
          >
          <el-button @click="yt.req('POST', '/web/inspection/rules/update')" :loading="yt.editObj.loading" size="mini" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 新增条件设置 -->
    <template>
      <div style="display: inline; ">
        <el-dialog :title="$t('xinzengtiaojianshezhi')" :visible.sync="showCondition" width="70%">
          <div v-if="showCondition" style="flex:1;" class="dialog-scroller">
            <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
              <el-form-item :label="$t('qishishuliang')" required>
                <yi_number_input :type="'number'" :start.sync="yt.editObj.addObj.startQuantity" :precision="2"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('jieshushuliang')" required>
                <yi_number_input :type="'number'" :start.sync="yt.editObj.addObj.endQuantity" :precision="2"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('yangbenshuliang')">
                <yi_number_input :type="'number'" :start.sync="yt.editObj.addObj.sampleQuantity" :precision="2"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('jianyanbaifenbi(%)')">
                <yi_number_input :type="'number'" :start.sync="yt.editObj.addObj.inspectionPercentage" :precision="2"></yi_number_input>
              </el-form-item>
              <el-form-item :label="$t('zuixiaozhijianshu')" required>
                <yi_number_input :type="'number'" :start.sync="yt.editObj.addObj.minimumInspectionQuantity" :precision="2"></yi_number_input>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="cancelAndClose">{{ $t('quxiao') }}</el-button>
            <el-button :loading="yt.editObj.loading" size="mini" @click="addConditionSetting()" type="primary">
              {{ $t('baocun') }}
            </el-button>
          </span>
        </el-dialog>
      </div>
    </template>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_base_inspection_rules',
  data() {
    return {
      showCondition: false,
      tableData: [],
      index: 0,
      checkTimesSelectWindows: false,
      timePickers: [''], // 存储时间选择器的数组，初始时包含一个空值
      inspectionTimes: '',
      typeList: [],
      codeAndDesc: '',
      columns: [
        {
          label: 'zhijianguizebianma',
          prop: 'code',
          width: 180
        },
        {
          label: 'zhijianguizemingcheng',
          prop: 'name',
          width: 250
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 200
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 200
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 250
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ],
      columnsItem: [
        {
          label: 'paixu',
          type: 'index'
        },
        {
          label: 'qishishuliang',
          prop: 'startQuantity',
          type: 'number',
          width: 130
        },
        {
          label: 'jieshushuliang',
          prop: 'endQuantity',
          type: 'number',
          width: 130
        },
        {
          label: 'yangbenshuliang',
          prop: 'sampleQuantity',
          type: 'number',
          width: 130
        },
        {
          label: 'jianyanbaifenbi(%)',
          prop: 'inspectionPercentage',
          type: 'number',
          width: 130
        },
        {
          label: 'zuixiaozhijianshu',
          prop: 'minimumInspectionQuantity',
          type: 'number',
          width: 130
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      console.log(this.yt.get(1));
      this.yt.get(1);
    }, 300);
  },
  mounted() {
    // 确保yt2已经可用
  },
  methods: {
    clearTableData() {
      this.tableData = [];
    },
    // beforeNewAdd() {
    //   console.log('obj:', this.yt.editObj.conditionSettingVOS);
    //   // return obj;
    // },
    removeByIndex(index) {
      this.yt.editObj.conditionSettingVOS.splice(index, 1);

    },

    addConditionSetting() {
     
      // 推送新对象到 this.yt.editObj.conditionSettingVOS 中
      if (this.yt.editObj.conditionSettingVOS) {
        this.yt.editObj.conditionSettingVOS.push(this.utils.copy(this.yt.editObj.addObj));
      }else{
        this.yt.editObj.conditionSettingVOS = [this.utils.copy(this.yt.editObj.addObj)];
      }

      // 隐藏条件
      this.showCondition = false;
    },

    cancelAndClose() {
      this.showCondition = false; // 关闭窗口
    },

    deleteRow(index, rows) {
      this.$refs.yt2.list.splice(index, 1);
    },
    move(index, type) {
      console.log('选中', index);
      if (type == 1) {
        /* //上移
          let index = 0;
          for (let i = 0; i < this.$refs.yt2.list.length; i++) {
            if (this.$refs.yt2.list[i].checked == true) {
              index = i
              break
            }
          } */
        console.log('索引', index);
        if (index > 0) {
          let tempsArr = this.utils.copy(this.$refs.yt2.list);
          let temp = tempsArr[index - 1];
          // temp.checked = true
          tempsArr[index - 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.$refs.yt2.list = tempsArr;
          console.log('交换位置后', this.$refs.yt2.list);
          this.setCurrent(this.$refs.yt2.list[index - 1]);
        }
      }
      if (type == 2) {
        /* //下移
          let index = 0;
          for (let i = 0; i < this.$refs.yt2.list.length; i++) {
            if (this.$refs.yt2.list[i].checked == true) {
              index = i
              break
            }
          } */
        console.log('索引', index);
        if (index < this.$refs.yt2.list.length - 1) {
          let tempsArr = this.utils.copy(this.$refs.yt2.list);
          let temp = tempsArr[index + 1];
          tempsArr[index + 1] = tempsArr[index];
          tempsArr[index] = temp;
          this.$refs.yt2.list = tempsArr;
          console.log('交换位置后', this.$refs.yt2.list);
          this.setCurrent(this.$refs.yt2.list[index + 1]);
        }
      }
    },
    /* setCurrent(row) {
        this.$refs.singleTable.setCurrentRow(row);
      }, */
    addRow(rows) {
      console.log('增加一行', rows);
      this.$refs.yt2.list.push({
        inspectionTimes: ''
      });
    },
    openTimePickerDialog() {
      this.checkTimesSelectWindows = true;
      // 检查list是否为空，如果为空，则自动添加一个空行
      this.$nextTick(() => {
        if (this.$refs.yt2.list.length === 0 && this.yt.editObj.inspectionTimes == null) {
          this.$refs.yt2.list.push({ inspectionTimes: '' });
        }
        if (this.yt.editObj.inspectionTimes) {
          const inspectionTimesArray = this.yt.editObj.inspectionTimes.split(',');
          console.log('inspectionTimes', this.yt.editObj.inspectionTimes);
          console.log('inspectionTimesArray', inspectionTimesArray);
          for (let index = 0; index < inspectionTimesArray.length; index++) {
            const element = inspectionTimesArray[index];
            console.log('element', element);
            if (this.$refs.yt2.list.length < inspectionTimesArray.length) {
              this.$refs.yt2.list.push({ inspectionTimes: element });
              console.log('list', this.$refs.yt2.list);
            }
          }
        }
      });
    },

    addTimePicker() {
      // 增加一个新的时间选择器
      this.timePickers.push('');
    },
    removeTimePicker(index) {
      // 移除指定索引的时间选择器
      if (this.timePickers.length > 1) {
        this.timePickers.splice(index, 1);
      }
    },
    // saveTimes() {
    //   console.log("保存",this.$refs.yt2.list)
    //   if (this.$refs.yt2.list.some((time, index) => this.$refs.yt2.list.indexOf(time) !== index)) {
    //     this.utils.errorMessage(this.$t('cunzaichongfushijian'));
    //     return;
    //   }
    //   this.yt.editObj.inspectionTimes = this.$refs.yt2.list.map(item => {
    //     return (item.inspectionTimes) ? item.inspectionTimes : '';
    //   }).join(',');

    //   // 清空yt2.list数据
    //   // this.$refs.yt2.list = [];
    //   this.checkTimesSelectWindows = false; // 关闭窗口
    // }
    saveTimes() {
      const timesSet = new Set();
      const hasDuplicate = this.$refs.yt2.list.some(item => {
        if (timesSet.has(item.inspectionTimes)) {
          return true; // 找到重复的值
        }
        timesSet.add(item.inspectionTimes);
        return false;
      });

      if (hasDuplicate) {
        this.utils.errorMessage(this.$t('cunzaichongfushijian'));
        return;
      }

      this.yt.editObj.inspectionTimes = this.$refs.yt2.list
        .map(item => {
          return item.inspectionTimes ? item.inspectionTimes : '';
        })
        .join(',');

      // 清空yt2.list数据
      // this.$refs.yt2.list = [];
      this.checkTimesSelectWindows = false; // 关闭窗口
    },

    checkTimesSelect() {
      this.checkTimesSelectWindows = true;
      console.log('this.checkTimesSelectWindows', this.checkTimesSelectWindows);
    },
    async getInspectionList() {
      return await this.http
        .get(
          '/web/quality/inspection/method/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 100,
              inspectionType: this.yt.editObj.inspectionType
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.typeList = response.data.rows || [];
        })
        .catch(() => {});
    },
    inspectionTypeChange(value) {
      this.getInspectionList();
      setTimeout(() => {
        this.yt.editObj.inspectionMethodId = '';
      }, 100);
      console.log('inspectionTypeChange', value);
      this.$forceUpdate();
    },
    getProcedureCode() {
      this.http.get('/web/craft/basic/work/procedure/list').then(res => {
        this.codeAndDesc = res.data;
        if (this.yt.editObj.action == 'xinzeng') {
          this.yt.editObj.basicWorkProcedureId = this.codeAndDesc[0].id;
        }
      });
    },
    setDefaultValue() {
      this.yt.editObj.inspectionType = 1;
      // this.yt.editObj.enabled = 1
      this.yt.editObj.enabled = true;
    }
  }
};
</script>
